import { render, staticRenderFns } from "./realTime.vue?vue&type=template&id=768f0b90&scoped=true"
import script from "./realTime.vue?vue&type=script&lang=js"
export * from "./realTime.vue?vue&type=script&lang=js"
import style0 from "./realTime.vue?vue&type=style&index=0&id=768f0b90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768f0b90",
  null
  
)

export default component.exports